/**
 * Payment provider rollout flags.
 *
 * When false: sellers link Stripe Payment Links / PayPal.me — BookAPT does not process funds.
 * When true: Stripe Connect OAuth + Super Admin approval (existing flow).
 */
export const STRIPE_CONNECT_REQUIRES_SUPER_ADMIN_APPROVAL = false;

/** When false, hide Stripe Payment Link setup; PayPal.me is the primary online pay option. */
export const SHOW_STRIPE_DIRECT_LINK_SETUP = false;

/** When true, merchants can onboard Stripe Connect for delivery checkout (C1). */
export const STRIPE_CONNECT_FOR_DELIVERY_ENABLED = true;
